module.exports = __webpack_public_path__ + "static/graphicsMobile-269ed1c8d9ac854e768cdd5f385dec5a.png";